<template>
  <Dialog v-model="dialogOpen" title="Configuración de cookies" class="manager" scroll-shadow padding spaced large>
    <div class="manager__subtitle">
      Utilizamos cookies propias y de terceros para fines analíticos y para mostrarte publicidad personalizada en base a un perfil elaborado
      a partir de tus hábitos de navegación (por ejemplo, páginas visitadas).
    </div>

    <div class="manager__body">
      <div class="manager__body__tabs">
        <div v-for="(cookie, i) in legalCookies" :key="cookie.key" class="manager__body__tabs__content">
          <hr v-if="i > 0" class="manager__body__tabs__separator" />
          <Toggle v-model="cookie.value" :disable="cookie.required" class="manager__body__tabs__toggle" />
          <a :href="`#${cookie.key}`" :class="{ selected: tab === cookie.key }" @click.prevent="tab = cookie.key">
            {{ cookie.name }}
            <span>{{ cookie.description }}</span>
          </a>
        </div>
      </div>

      <div class="manager__body__panels">
        <div v-for="cookie in legalCookies" :key="cookie.key" v-show="tab === cookie.key" class="manager__body__panel">
          <Toggle v-model="cookie.value" :disable="cookie.required" class="manager__body__panel__toggle" />
          <div class="manager__body__panel__title">{{ cookie.name }}</div>
          <p class="manager__body__panel__description">{{ cookie.description }}</p>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="manager__footer">
        <a target="_blank" href="/legal/politica-de-cookies">Más información</a>

        <div class="manager__footer__buttons">
          <Button class="manager__footer__buttons--desktop" btn-style="ghost" @click.native="save">Guardar mis preferencias</Button>
          <Button class="manager__footer__buttons--mobile" btn-style="secondary" @click.native="save">Guardar preferencias</Button>
          <Button @click.native="acceptAll">Aceptar todas</Button>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import Dialog from '@/lego/components/dialogs/Dialog.vue';
import { ref } from '@vue/composition-api';
import CookiesBus from '@/lego/utils/bus/cookies';
import Button from '@/lego/components/buttons/Button.vue';
import Toggle from '@/lego/components/toggles/Toggle.vue';
import Animation from '@/lego/components/tools/Animation.vue';
import { getLegalCookies, saveLegalCookies, acceptAllLegalCookies } from '@/lego/utils/navigator/cookies';

export default {
  components: { Toggle, Dialog, Button, Animation },

  setup() {
    const legalCookies = ref(getLegalCookies());
    const dialogOpen = ref(false);
    const tab = ref(legalCookies.value[0]?.key);

    CookiesBus.on('manager.open', () => {
      dialogOpen.value = true;
    });

    CookiesBus.on('manager.close', () => {
      dialogOpen.value = false;
    });

    function save() {
      saveLegalCookies(legalCookies.value);

      CookiesBus.emit('manager.close');
      CookiesBus.emit('banner.close');
    }

    function acceptAll() {
      acceptAllLegalCookies();

      CookiesBus.emit('manager.close');
      CookiesBus.emit('banner.close');
    }

    return { dialogOpen, tab, legalCookies, save, acceptAll };
  },
};
</script>

<style scoped lang="postcss">
.manager {
  @apply flex flex-col gap-y-xxs;

  &__subtitle {
    @apply text-xs md:text-sm;
  }

  &__body {
    @apply flex flex-row gap-x-md py-sm;

    &__tabs {
      @apply flex flex-col gap-y-xxs md:border-r-hairline md:border-neutral-semilight md:pr-xs md:min-w-[10.5rem];

      &__content {
        @apply relative;
      }

      a {
        @apply md:text-neutral-semidark flex flex-col gap-y-micro font-bold md:font-regular text-sm md:text-xs;

        &.selected {
          @apply md:font-bold md:text-support-dark;
        }

        span {
          @apply md:hidden font-regular text-xs;
        }
      }

      &__separator {
        @apply md:hidden mb-xxs border-neutral-semilight;
      }

      &__toggle {
        @apply absolute right-0 md:hidden;
      }
    }

    &__panels {
      @apply hidden md:block;
    }

    &__panel {
      &__title {
        @apply font-bold mb-xxs;
      }

      &__toggle {
        @apply float-right;
      }
    }
  }

  &__footer {
    @apply w-full flex flex-col-reverse md:flex-row justify-between items-center gap-xxs;

    a {
      @apply underline;

      &:hover {
        @apply no-underline;
      }
    }

    &__buttons {
      @apply w-full md:w-auto flex flex-col-reverse md:flex-row gap-xxxs;

      &--mobile {
        @apply md:hidden;
      }

      &--desktop {
        @apply hidden md:block;
      }

      buttons {
        @apply w-full md:w-auto;
      }
    }
  }
}
</style>
